import { z } from 'zod';
import { validateEmail } from '../common/email.js';
const NAME_CHARS = /^[\p{L}\s'-]+$/u;
const rsvpFirstNameSchema = z
    .string()
    .trim()
    .min(1, 'First name is required')
    .regex(NAME_CHARS, 'Cannot contain special characters or numbers');
const rsvpLastNameSchema = z
    .string()
    .trim()
    .min(1, 'Last name is required')
    .regex(NAME_CHARS, 'Cannot contain special characters or numbers');
export const attendeeFieldsSchema = z
    .object({
    first_name: rsvpFirstNameSchema,
    last_name: rsvpLastNameSchema,
    send_invite: z.boolean(),
    email: z.string().optional(),
})
    .superRefine((data, ctx) => {
    validateEmail(ctx, 'email', data.email, { requiredWhen: data.send_invite });
});
/** RSVP new-spouse form — email is always required to create the CRM contact. */
export const rsvpNewSpouseFieldsSchema = attendeeFieldsSchema.superRefine((data, ctx) => {
    validateEmail(ctx, 'email', data.email);
});
export const spouseRsvpSchema = z.object({
    contact_id: z.string().trim().min(1),
    first_name: rsvpFirstNameSchema,
    last_name: rsvpLastNameSchema,
    send_invite: z.boolean(),
    email: z.string().optional(),
});
export const rsvpSubmissionSchema = z.object({
    spouse: spouseRsvpSchema.optional(),
    guests: z.array(attendeeFieldsSchema).max(4, 'A maximum of 4 guests is allowed'),
});
